module.exports = __webpack_public_path__ + "img/bn5.89b9fa9b.png";